import fireSafety from "../blogs/fireSafety.jpg";
import fireDetectors from "../blogs/fireDetectors.png";
import img1 from "../../assets/blogs/img3.png";
import img2 from "../../assets/blogs/img1.png";
import img3 from "../../assets/blogsData/img1.png";
import f2 from "../../assets/blogsData/f2.png";
import f3 from "../../assets/blogsData/f3.png";
import s3 from "../../assets/blogsData/s3.png";
import s4 from "../../assets/blogsData/s4.png";
import s5 from "../../assets/blogsData/s5.png";
import d3 from "../../assets/blogsData/d3.png";
import d4 from "../../assets/blogsData/d4.png";
import a2 from "../../assets/blogsData/a1.png";
import a1 from "../../assets/blogsData/a2.png";
import a3 from "../../assets/blogsData/a3.png";
import c1 from "../../assets/blogsData/c1.png";
import c2 from "../../assets/blogsData/c2.png";
import c3 from "../../assets/blogsData/gren.jpg";

const blogs = [
  {
    id: 1,
    images: [fireSafety, f2, f3], // multiple images
    img: fireSafety, // fallback (first image)
    title: "Training Program ( Fire Safety )",
    desc: "Basic awareness training: Ideal for all employees, this type of training focuses on hazard identification, prevention, and emergency response procedures. ",
    personIMG:
      "https://framerusercontent.com/images/v0xx4IJ0QzD07LzPBOUBMr9mzI.png?scale-down-to=512",
    content: `
## Brand Discovery & Strategy
Digital agencies begin by understanding your business, audience, and goals. 
Through workshops, research, and audits, they identify what makes your brand unique and how to position it online.

## Website Design & Development
Your website is your digital storefront. A digital agency ensures it’s not only visually appealing 
but also functional, fast, and optimized for conversions.

**They focus on:**
- UI/UX design that keeps users engaged  
- Mobile responsiveness and accessibility  
- SEO-optimized and scalable code  
- Seamless user journeys that drive results  
    `,
  },
  {
    id: 2,
    images: [img2, s3],
    img: img2,
    personIMG: "https://randomuser.me/api/portraits/men/40.jpg",
    time: "August 2024",
    title: "SUSPA Pneumatics for Supplier Excellence",
    desc: "Receiving this award from a globally respected company like SUSPA Pneumatics is a great honor for our entire team. It reflects our shared vision for quality and performance.",
    content: `
## Strong Digital Presence
A strong digital presence builds trust, improves discoverability, and enables direct customer engagement.
    `,
  },
  {
    id: 3,
    images: [img1, s4, s5],
    img: img1,
    time: "August 2025",
    title: "Recognized by SUSPA Pneumatics for Supplier Excellence",
    desc: "Twin Star Industries Receives Supplier Excellence Award from SUSPA Pneumatics",
    personIMG:
      "https://framerusercontent.com/images/mlWTorGnAouc4eg56LjLruBmQ4.png?scale-down-to=512",
    content: `
##We are proud to announce that Twin Star Industries has been honored with the Supplier Excellence Award by SUSPA Pneumatics India Pvt Ltd.

This prestigious recognition reflects our consistent performance in delivering high-quality components, maintaining timely deliveries, and supporting the operational excellence of SUSPA Pneumatics. As a strategic supplier partner, we have always aligned with their values of precision, innovation, and reliability.`,
  },
  {
    id: 4,
    images: [fireDetectors, d3, d4],
    img: fireDetectors,
    title: "Twin Star Industries: Fire Safety Improvements In Shop Floor",
    desc: "Discover how digital agencies help businesses stand out in crowded markets through branding.",
    personIMG:
      "https://framerusercontent.com/images/YCaU1sZTf56GISKKOjKcCEVovQo.png?scale-down-to=512",
    content: `
## Shop Floor Fire Safety
Safety in shop floors is critical for both employee welfare and production stability. 
This blog covers improvements in fire detection, alarm systems, and emergency protocols.
    `,
  },
  {
    id: 5,
    images: [c2,c1,c3],
    img: img3,
    personIMG: "https://randomuser.me/api/portraits/women/22.jpg",
    title: "CERTIFICATIONS & MILESTONES",
    desc: "Twin Star Industries  has established and applies a Quality Management System for Manufacture of Forging Machined Components Ferrous & Non Ferrous Machined Components.",
    content: `
## Digital Agencies in 2025
Expect automation, AI-driven insights, and personalization to dominate digital marketing strategies.
    `,
  },
  {
    id: 6,
    images: [a1 , a2, a3],
    img: img3,
    personIMG: "https://randomuser.me/api/portraits/women/22.jpg",
    title: "Basic first aid awareness program",
    desc: "This program is designed to educate participants on essential first aid skills to respond effectively during emergencies.",
    content: `
## Digital Agencies in 2025
Expect automation, AI-driven insights, and personalization to dominate digital marketing strategies.
    `,
  },
];

export default blogs;
